// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"258":"b43793cc","478":"ad7bf04a","722":"b43793cc","851":"ad7bf04a"}[chunkId] + ".chunk.css";
};